export default {
  label: {
    id: 'bo_sellers-orders-components-orders_table-actions-confirm_selected_orders',
    defaultMessage: 'Confirm selected orders',
  },
  modalMessage: {
    id: 'bo_sellers-orders-components-orders_table-actions-bulk_action_confirm_info_message',
    defaultMessage:
      'You can only confirm selected "To be processed" orders. Is that cool with you?',
  },
  modalConfirm: {
    id: 'bo_sellers-orders-components-orders_table-actions-confirm_concerned_orders',
    defaultMessage: 'Yes, confirm orders',
  },
  modalCancel: {
    id: 'bo_sellers-orders-components-orders_table-actions-cancel',
    defaultMessage: "No, don't confirm",
  },
  toastSuccess: {
    id: 'bo_sellers-orders-components-orders_table-orders_confirmed',
    defaultMessage: 'The orders you selected are confirmed!',
  },
} as const
